import { useState } from 'react';
import './BranchRow.css';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import TextInput from '/src/components/UI/TextField/TextInput';

function ChipListEditor({ list, placeholder, emptyLabel, onAdd, onRemove }) {
    const [draft, setDraft] = useState('');

    const addValue = () => {
        const seen = new Set(list);
        const newValues = [];
        for (const part of draft.split(';')) {
            const value = part.trim();
            if (value === '' || seen.has(value)) continue;
            seen.add(value);
            newValues.push(value);
        }
        if (newValues.length > 0) {
            onAdd(newValues);
        }
        setDraft('');
    };

    return (
        <>
            <div className="branch_values_list">
                {list.map((value) => (
                    <span key={value} className="branch_value_chip">
                        {value}
                        <i className="fas fa-times" onClick={() => onRemove(value)} />
                    </span>
                ))}
                {list.length === 0 && <span className="branch_values_empty">{emptyLabel}</span>}
            </div>
            <div className="branch_value_input_row">
                <TextInput
                    className="branch_value_input"
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            addValue();
                        }
                    }}
                    placeholder={placeholder}
                />
                <IconButton onClick={addValue} className="editor-iconButton main_add-button button_center" icon="fas fa-plus" />
            </div>
        </>
    );
}

function BranchRow({ branch_id, values = [], forbidden = [], is_default, canDelete = true, child, index, idx, first, setValue, setDefault, deleteValue, move }) {
    const [open, setOpen] = useState(!!first);

    return (
        <div className="branch_row">
            <div className="branch_row_top" onMouseDown={(e) => e.stopPropagation()}>
                {is_default && <span className="branch_default_badge">Default</span>}
                <TextInput
                    className="branch_row_name"
                    defaultValue={child?.text || ''}
                    onBlur={(e) => setValue(branch_id, 'text', e.target.value)}
                    placeholder="Branch name"
                />
                <div className="actions">
                    {idx !== 0 && first !== true && (
                        <IconButton onClick={() => move(index, index - 1)} className="editor-iconButton main_add-button button_center profil_action" icon="fas fa-chevron-up" />
                    )}
                    {idx !== -1 && (
                        <IconButton onClick={() => move(index, index + 1)} className="editor-iconButton main_add-button button_center profil_action" icon="fas fa-chevron-down" />
                    )}
                    <IconButton onClick={() => setOpen((o) => !o)} className="editor-iconButton main_add-button button_center edit_action" icon="fas fa-edit" />
                    {canDelete ? (
                        <IconButton onClick={() => deleteValue({ branch_id })} className="editor-iconButton main_add-button button_center delete_action" icon="fas fa-trash" />
                    ) : (
                        <i
                            className="fas fa-trash branch_delete_disabled"
                            title={is_default ? "Can't delete the default branch — set another branch as default first" : "Can't delete the last remaining branch"}
                        />
                    )}
                </div>
            </div>

            {open && (
                <div className="branch_row_body">
                    <label className="branch_default_toggle">
                        <input type="checkbox" checked={!!is_default} onChange={() => setDefault(branch_id)} />
                        Default branch (used when no value matches)
                    </label>
                    
                    {!is_default && (
                        <>
                            <div className="branch_section">
                                <label className="branch_section_title">Matches when the value contains:</label>
                                <ChipListEditor
                                    list={values}
                                    placeholder="Add a value (or a;b;c) and press Enter"
                                    emptyLabel="No value yet"
                                    onAdd={(newValues) => setValue(branch_id, 'values', [...values, ...newValues])}
                                    onRemove={(value) => setValue(branch_id, 'values', values.filter((v) => v !== value))}
                                />
                            </div>

                            <div className="branch_section">
                                <label className="branch_section_title">Excluded if the message contains any of:</label>
                                <ChipListEditor
                                    list={forbidden}
                                    placeholder="Add a forbidden word (or a;b;c) and press Enter"
                                    emptyLabel="No forbidden word"
                                    onAdd={(newWords) => setValue(branch_id, 'forbidden', [...forbidden, ...newWords])}
                                    onRemove={(word) => setValue(branch_id, 'forbidden', forbidden.filter((w) => w !== word))}
                                />
                            </div>
                        </>
                    )}
                </div>
            )}
        </div>
    );
}

export default BranchRow;
